import { MediaItem } from '@/types/greenroom/media.types';
import { Get } from '../helpers';

const GetMedia = (meetingId: number, token: string): Promise<MediaItem[] | null> => {
  const url = `${import.meta.env.VITE_GREENROOM_API}/v2/greenroom/media/${meetingId}`;

  return Get({
    path: url,
    headers: {
      'bl-token': token,
      'bl-global-resource': 'false',
    },
    useCache: true,
    cacheTtl: 60,
  });
};

export default GetMedia;
